import { Organization, StripePriceLookupKey, UnsavedOrganization } from '@paragon/contract-library';

import { UserService } from '../connections';

export function pGetOrganizations() {
  return UserService.get<readonly Organization[]>('organizations');
}

export function pGetOrganization(name: string) {
  return UserService.get<Organization>(`organizations/${name}`);
}

export function getLinkGuid(name: string) {
  return UserService.get<{ name: string; linkGuid: string }>(`organizations/${name}/linkGuid`);
}

export function pCreateOrganization(newOrganization: UnsavedOrganization) {
  return UserService.post<Organization>('organizations', { data: newOrganization });
}

export function pUpdateOrganization(organization: Organization) {
  return UserService.post<Organization>(`organizations/${organization.name}`, { data: organization });
}

export function pGetCustomers(organizationName: string) {
  return (
    UserService.get<{ readonly customers: readonly Organization[] }>(`organizations/${organizationName}/customers`)
      .then((data) => data.customers)
      // for old documents to be removed
      .catch(() => {
        console.warn('organization does not have customers field, please update db');
        return [];
      })
  );
}

export function pAddCustomerToOrganization(organizationName: string, customerOrgName: string) {
  return UserService.put<{ readonly customers: readonly Organization[] }>(
    `organizations/${organizationName}/customers/${customerOrgName}`,
  );
}

export function pRemoveCustomerToOrganization(organizationName: string, customerOrgName: string) {
  return UserService.delete<{ readonly customers: readonly Organization[] }>(
    `organizations/${organizationName}/customers/${customerOrgName}`,
  );
}

export function getStripeSubscription(organizationName: string) {
  return UserService.get<{
    readonly name: 'none' | StripePriceLookupKey;
    readonly cancelAtPeriodEnd?: boolean;
    readonly currentPeriodEnd?: number;
  }>(`organizations/${organizationName}/stripeSubscription`);
}

export function checkout(priceLookupKey: StripePriceLookupKey, successUrl: string, cancelUrl: string) {
  return UserService.post<{ readonly checkoutUrl: string }>(`organizations/checkout`, {
    data: { priceLookupKey, successUrl, cancelUrl },
  });
}

export function cancelSubscription() {
  return UserService.post<{ readonly checkoutUrl: string }>(`organizations/cancelSubscription`);
}

export function uncancelSubscription() {
  return UserService.post<{ readonly checkoutUrl: string }>(`organizations/uncancelSubscription`);
}
